/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import useCopyToClipboard from 'react-use/lib/useCopyToClipboard';
import { useOutlet } from 'react-router-dom';
import { TechDocsIndexPageProps } from '@backstage/plugin-techdocs';
import { columns as customColumns } from './columns';
import { createCopyDocsUrlAction, shareDocsAction } from './actions';
import { shareInOutlookAndTeams } from '../../utils/shareUtility';
import { CustomTechDocsPage } from './CustomTechDocsPage';

export const TechDocsIndexPage = (props: TechDocsIndexPageProps) => {
  const outlet = useOutlet();
  const [, copyToClipboard] = useCopyToClipboard();

  const customActions = [
    createCopyDocsUrlAction(copyToClipboard),
    shareDocsAction(shareInOutlookAndTeams),
  ];

  return (
    outlet || (
      <CustomTechDocsPage
        columns={customColumns}
        actions={customActions}
        {...props}
      />
    )
  );
};
